import React, { useEffect, useState } from 'react';
import { arrayMoveImmutable } from 'array-move';
import CategoryListSortable from '@/components/tecdocSettings/TecdocMenuCreate/CategoryList';
import { Breadcrumb, Button, Skeleton } from 'antd';
import CreateMainCategory from '@/components/tecdocSettings/TecdocMenuCreate/CreateMainCategory';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useFetchCategories from '@/hooks/adminTecdoc/useFetchCategories';
import useChangeSort from '@/hooks/adminTecdoc/useChangeSort';
import useUpdateCategory from '@/hooks/adminTecdoc/useUpdateCategory';
import { useSelector } from 'react-redux';
import api from '@/services/api'; // Assuming you have a configured API service
import { useTranslation } from 'react-i18next';

const TecdocSubCategories = () => {
  const { categoryId } = useParams();
  const siteSettings = useSelector((state) => state?.settings); // dil ayarı buradan
  const [category, setCategory] = useState({});

  const fetchCategories = useFetchCategories(categoryId); // sub-categories için
  const changeSort = useChangeSort();
  const navigate = useNavigate();

  const [showCreateModal, setShowCreateModal] = useState(false);


  const [parentCategory, setParentCategory] = useState({});

  const [loadingParentCategory, setLoadingParentCategory] = useState(true);

  const { t } = useTranslation()

  // Kategori sıralama değişikliği
  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newList = arrayMoveImmutable(fetchCategories.categories, oldIndex, newIndex);
    fetchCategories.setCategories(newList);

    const ids = newList.map((item, index) => [item?.id, index]);
    changeSort.changeSort(ids);
  };

  // Yeni kategori oluşturulunca ekle
  const onCreateHandler = (newCategory) => {
    fetchCategories.setCategories((prev) => [...prev, newCategory]);
    setShowCreateModal(false);
  };

  // Güncellenmiş kategori listede değiştir
  const onUpdateHandler = (updated) => {
    fetchCategories.setCategories((prev) =>
      prev.map((f) => (f?.id === updated?.id ? updated : f))
    );
  };

  // Tıklanınca alt kategoriye git
  const onClickHandler = (e) => {
    navigate(`/management/catalog-tecdoc/${categoryId}/subcategories/${e?.id}`);
  };


  const fetchCategoryDetailById = async (id) => {
    setLoadingParentCategory(true);
    try {

      const response = await api()({
        url: `/webshop/management/tecdoc-menu-install/${id}`,
        method: 'GET',
      })

      setParentCategory(response?.data?.data || {});

    }
    catch (error) {
      console.error('Error fetching category detail:', error);
      setParentCategory({});
    }
    finally {
      setLoadingParentCategory(false);
    }

  }

  // Üst kategori verisini çek (breadcrumb için)
  useEffect(() => {
    if (!categoryId) return;
    fetchCategoryDetailById(categoryId)
  }, [categoryId]);



  return (
    <Skeleton loading={fetchCategories.loading || loadingParentCategory} active>
      {/* Yeni alt kategori oluşturma modalı */}
      <CreateMainCategory
        parentId={categoryId}
        onCreate={onCreateHandler}
        show={showCreateModal}
        onCancel={() => setShowCreateModal(false)}
      />

      {/* Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Breadcrumb */}
        <div>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/management/catalog-tecdoc">Categories</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {parentCategory?.name?.[siteSettings?.Language?.toUpperCase() || 'EN'] || t('unnamed')}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        {/* Yeni kategori butonu */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Button onClick={() => setShowCreateModal(true)} type="primary">
            New Category
          </Button>
        </div>
      </div>

      {/* Liste */}
      <div className="mt-3">
        <CategoryListSortable
          items={fetchCategories.categories}
          onClickItem={onClickHandler}
          onUpdate={onUpdateHandler}
          onClickDelete={(id) =>
            fetchCategories.setCategories((prev) => prev.filter((e) => e?.id !== id))
          }
          onSortEnd={onSortEnd}
        />
      </div>
    </Skeleton>
  );
};

export default TecdocSubCategories;
